import { ISODateTimeString, ISODateString } from './types'
import { Optional } from '../types'

/**
 * Normalise an ISO Date Time string to use Z instead of +00:00
 * 2024-06-23T07:23:35.299Z
 *
 * @param isoDateTimeString
 */
export function normaliseIsoDateTimeString<
  T extends Optional<ISODateTimeString | number>
>(isoDateTimeString: T) {
  return isoDateTimeString
    ? new Date(isoDateTimeString).toISOString()
    : isoDateTimeString
}

/**
 * Normalise an ISO Date string to strip potential time
 * 2024-06-23T07:23:35.299Z => 2024-06-23
 *
 * @param isoDateTimeString
 */
export function normaliseIsoDateString<
  T extends Optional<ISODateString>
>(isoDateTimeString: T) {
  return isoDateTimeString
    ? isoDateTimeString.split('T')[0]
    : isoDateTimeString
}

/**
 * Format a date string (2024-06-23) from the
 * UTC parts of a Date instance
 *
 * @param date
 */
export function formatUtcIsoDate(date: Date) {
  return [
    date.getUTCFullYear(),
    (date.getUTCMonth() + 1).toString().padStart(2, '0'),
    date.getUTCDate().toString().padStart(2, '0'),
  ].join('-')
}

/**
 * Format a date string (2024-06-23) from the
 * local parts of a Date instance
 *
 * @param date
 */
export function formatLocalIsoDate(date: Date) {
  return [
    date.getFullYear(),
    (date.getMonth() + 1).toString().padStart(2, '0'),
    date.getDate().toString().padStart(2, '0'),
  ].join('-')
}
